import { useCallback, useEffect, useState } from "react";
import useAuthentication from "@hooks/useAuthentication";
import {
  HelpNode,
  HelpNodeProps,
  RecursiveAccordion,
} from "./components/recursiveAccordian";
import { Box, TextField, Typography } from "@mui/material";

// 🔁 Map API node to HelpNodeProps
function mapToHelpNodeProps(node: any): HelpNodeProps {
  return {
    name: node.name,
    text: undefined,
    children: node.children?.map(mapToHelpNodeProps),
  };
}

// 🔍 Filter tree recursively
function filterTree(node: HelpNodeProps, term: string): HelpNodeProps | null {
  const match = node.name?.toLowerCase().includes(term.toLowerCase());

  const filteredChildren = node.children
    ?.map((child) => filterTree(child, term))
    .filter(Boolean) as HelpNodeProps[];

  if (match || filteredChildren.length > 0) {
    return {
      ...node,
      children: filteredChildren,
    };
  }

  return null;
}

function HelpPage() {
  const { permissions } = useAuthentication();
  const [expandedName, setExpandedName] = useState<string>("");
  const [helpTree, setHelpTree] = useState<HelpNode>({ children: [] });
  const [filteredTree, setFilteredTree] = useState<HelpNode>({ children: [] });

  const [searchTerm, setSearchTerm] = useState("");

  const handleAccordionChange = useCallback((name: string) => {
    setExpandedName(name);
  }, []);

  const logAllNames = (nodes: HelpNodeProps[]) => {
  nodes.forEach((node) => {
    console.log(node.name); // Log current node's name

    // Recursively check children
    if (node.children && node.children.length > 0) {
      logAllNames(node.children);
    }
  });
};




useEffect(() => {
  if (!permissions?.length) return;
  
  const reportsSection = permissions[0]?.children;
  if (reportsSection?.length) {
    const children = reportsSection.map(mapToHelpNodeProps);
    setHelpTree({ children });
    setFilteredTree({ children });
  }
  
  logAllNames(reportsSection);
  console.log(reportsSection.map((child) => child.name));
}, [permissions]);

// 🔍 Filter tree as search term changes
useEffect(() => {
  if (!searchTerm.trim()) {
    setFilteredTree(helpTree); // Reset to full tree
    return;
  }
    
    const filteredChildren = helpTree.children
    ?.map((node) => filterTree(node, searchTerm))
    .filter((node): node is HelpNodeProps => node !== null); // ✅
    
    
    setFilteredTree({ children: filteredChildren });
  }, [searchTerm, helpTree]);

  return (
    <div style={{ padding: 16 }}>
      <Box
        sx={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
        }}
      >
        <Typography fontWeight="bold" fontSize="1.2rem">FAQ</Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <TextField
            variant="outlined"
            size="small"
            label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ backgroundColor: "white", borderRadius: 1, width: 200 }}
          />
        </Box>
      </Box>

      {filteredTree.children?.length ? (
        filteredTree.children.map((node, i) => (
          <RecursiveAccordion
            key={i}
            node={node}
            searchTerms={[searchTerm]}
            expandedNode={expandedName}
            onAccordionChange={handleAccordionChange}
          />
        ))
      ) : (
        <p>No report help content available.</p>
      )}
    </div>
  );
}

export default HelpPage;
